<template>
    <div id="endorsements">
        <carousel></carousel>
        <h1 class="text-primary font-weight-bold mt-4">Endorsements</h1>
        <div><a href="https://twitter.com/BillyCorben/status/1582085702346342400" target="_blank">
        <img class="mb-3" :src="require('@/assets/img/Billy Corben.png')" fluid alt="Billy Corben" style="height: 300px;padding: 50px" /></a></div>
        <div><a href="https://www.instagram.com/p/CjsaEEXLt8v/" target="_blank">
        <img class="mb-3" :src="require('@/assets/img/MDCCPTA.jpeg')" fluid alt="MDCCPTA"  /></a></div>
        <div><a href="https://eedition.miamiherald.com/popovers/dynamic_article_popover.aspx?artguid=df00d51d-88f1-4643-b65a-c41d4de2feea&appcode=MIAHER&eguid=1ee78c7b-4d54-4b0d-b4c8-f790fb069c05&pnum=63#" target="_blank">
        <img class="mb-3" :src="require('@/assets/img/Herald.png')" fluid alt="Miami Herald" style="height: 324px;" /></a></div>
        <div><a href="https://www.miamitimesonline.com/electionnewshub/the-miami-times-recommends-school-board-referendum/article_d2bba892-553d-11ed-ad2c-8fbe6ee24968.html" target="_blank">
        <img class="mb-3" :src="require('@/assets/img/Miami Times.png')" fluid alt="Miami New Times" style="height: 324px;" /></a></div>
        <div><a href="https://communitynewspapers.com/coral-gables-news/vote-yes-210-for-teachers-school-safety/" target="_blank">
        <img class="mb-3" :src="require('@/assets/img/CG community news banner.png')" fluid alt="Coral Gables Community News" style="width: 550px;" /></a></div>

       
 
        <footer-bar />
      <!-- END -->
    </div>
  </template>

<script>
    import Carousel from "@/views/Home/Carousel";
    import FooterBar from "@/components/FooterBar.vue";

    export default{
        name: "Endorsements",
        components: {Carousel, FooterBar},
        data: () => ({}),
    };
</script>